import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { HomeSigesrComponent } from './home-sigesr/home-sigesr';

export const routes: Routes = [
  { 
    path: '', 
    component: HomeSigesrComponent, 
    canActivate: [authGuard],
    title: 'Applications | SIGESR'
  },
  { 
    path: '**', 
    redirectTo: '' 
  }
];